import axios from 'axios';

export function scheduleServiceWebServiceLog(requestResponse) {
  let url = `${window.logsApiUrl}/WebServiceLog`;
  let payload = {
    id: 0,
    method: '',
    request: JSON.stringify(requestResponse.request),
    response: JSON.stringify(requestResponse.response),
    message: '',
    exception: '',
    applicationSource: '',
    appointmentId: 0,
    typeId: requestResponse.typeId,
    responseId: '',
    campaignID: parseInt(window.campaignId),
    accountId: parseInt(window.accountId),
    dRaiverAccountId: '',
    sessionId: window.tid,
    status: requestResponse?.status,
    name: `${requestResponse.request.firstName} ${requestResponse.request.lastName}`,
    year: requestResponse?.request?.modelYear,
    make: requestResponse?.request?.make,
    model: requestResponse?.request?.model,
    vin: requestResponse?.request?.vin,
  };

  axios
    .post(url, payload)
    .then(() => {})
    .catch((e) => console.log(e));
}
